import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DatastoreService} from '../../../../../service/datastore/datastore.service';
import {FirebaseService} from '../../../../../service/firebase/firebase.service';
import {VorhersageHeute, VorhersageZehnTage} from '../../../../../model/vorhersagen/vorhersage-zehn-tage';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {WerteConverterUtil} from '../../../../../util/werte-converter-util';
import {take} from 'rxjs/operators';

@Component({
  selector: 'app-automatisiert-brandenburg-aktuell',
  templateUrl: './automatisiert-brandenburg-aktuell.component.html',
  styleUrls: ['./automatisiert-brandenburg-aktuell.component.css', '../automatisiert.component.css']
})
export class AutomatisiertBrandenburgAktuellComponent implements OnInit {

  // GLOBAL_IDS = ['V_MSWR_L_102700', 'V_MSWR_L_103680', 'V_MSWR_L_I53029', 'V_MSWR_L_AW0227', 'V_MSWR_L_103790', 'V_MSWR_L_104960', 'V_MSWR_L_I53033', 'V_MSWR_L_AW0051', 'V_MSWR_L_F925XX', 'V_MSWR_L_AW0043', 'V_MSWR_L_F518XX', 'V_MSWR_L_AW0362', 'V_MSWR_L_AW0048', 'V_MSWR_L_AW0353', 'V_MSWR_L_AW0369', 'V_MSWR_L_AW0044', 'V_MSWR_L_AW0047'];
  GLOBAL_IDS = ['V_MSWR_L_102700', 'V_MSWR_L_103680', 'V_MSWR_L_I53029', 'V_MSWR_L_AW0227', 'V_MSWR_L_103790', 'V_MSWR_L_104960', 'V_MSWR_L_I53033', 'V_MSWR_L_AW0051', 'V_MSWR_L_F925XX', 'V_MSWR_L_AW0043', 'V_MSWR_L_F518XX', 'V_MSWR_L_AW0362', 'V_MSWR_L_AW0048', 'V_MSWR_L_AW0353', 'V_MSWR_L_AW0369', 'V_MSWR_L_AW0044', 'V_MSWR_L_AW0047'];


  displayedColumns = ['ort', 'wetter', 'temperatur'];
  dataSource = new MatTableDataSource<VorhersageHeute>();

  @Input() vorhersagen: Array<VorhersageHeute>;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(public converter: WerteConverterUtil) {
  }

  ngOnInit() {
    this.loadData();
  }

  private loadData() {
    if (this.vorhersagen !== undefined) {
      this.dataSource.data = this.vorhersagen.filter(v => this.GLOBAL_IDS.includes(v.ort.id));
    }
  }

  ngAfterViewInit() {
    this.dataSource.sortingDataAccessor = this.getSortingAccessor();
    this.dataSource.sort = this.sort;
  }

  private getSortingAccessor() {
    return (element: VorhersageHeute, property) => {
      switch (property) {
        case 'ort':
          return element.ort.name;
        case 'wetter':
          return element.tag00.werteGanzerTag.bewoelkung.text;
        case 'temperatur':
          return element.tag00.werteGanzerTag.luftTemperaturMaximum.wert;
      }
    };
  }

}
